import React, { useId } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import TagInput from '@wix/da-shared-react/pkg/TagInput';

interface Props {
  fieldName: string;
  label: string;
  placeholder: string;
  noBottomSpacing?: boolean;
}

const TagsField: React.FC<Props> = ({ fieldName, label, placeholder, noBottomSpacing }) => {
  const id = useId();
  const { control, errors } = useFormContext();
  const {
    field: { value, onChange },
  } = useController({ name: fieldName, control });
  const error = errors[fieldName];

  return (
    <TagInput
      withCopy
      id={id}
      label={label}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      noBottomSpacing={noBottomSpacing}
      validationResult={error && ('error' as any)}
      details={error?.message}
    />
  );
};
TagsField.displayName = 'TagsField';

export default TagsField;
